// extracted by mini-css-extract-plugin
export default {"root":"SrBzYieQf8P9Ergjyvh7"};